var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-map',{attrs:{"center":_vm.center,"zoom":_vm.zoom}},_vm._l((_vm.mapItems),function(m,index){return _c('tk-custom-marker',{key:index,attrs:{"position":m.position,"price":m.price,"clicking":_vm.selectedClicks[index]},on:{"click":function($event){return _vm.clickMarker(m, index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }